module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYBAMAAAASWSDLAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAnUExURUdwTDDFMzDEMzDFMzDFMjDHMDDPMDDGMzDFMzDGMDDFMzDFMzDFNE0JizwAAAAMdFJOUwDQoPBpIBBQsjKvny0H7xYAAAClSURBVBjTVZCxDQIxDEW/TjmmSHEDXI+CKKgRBQNQHDPQMgJFhqBkBJoQTofgD4WT+ED5lb+ebH8bANqtDdc9sto7RZ/iTsxaptpQtRFzns0kHWutL3FAo/XDsMNBTbewI3YKcOQTtx/gC5YrBQxg9H0BZDJNAWIsHfoCggyI3hTwTqMdMpDRsjT6DDjmOM6WXf+glKDVCfVx1dlo+xx70PfMr/oC9X2X9lp0TcMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/new-images/completed.png
// module id = 42
// module chunks = 0